import { z } from "@msuite/utils/lib/zod";
import { defineQuery } from "@rocicorp/zero";
import { zql } from "../zql";

export const crewQueries = {
	// A crew is visible to the organisation whose board it stands on and to the organisation whose
	// people fill it. For an ordinary crew those are the same; for a partner crew they differ, and
	// the second arm is the only way the partner reaches its own column at all — the plan it hangs
	// off belongs to someone else and is invisible to it.
	//
	// The two arms are the two arms of the crews read policy, deliberately: what the sync path shows
	// and what a policy-governed read returns should not need separate reasoning.
	byId: defineQuery(z.object({ crewId: z.string() }), ({ args, ctx }) => {
		return zql.crews
			.where("id", "=", args.crewId)
			.where(({ or, cmp, exists }) =>
				or(
					cmp("orgId", "=", ctx.orgId),
					exists("plan", (plan) => plan.where("orgId", "=", ctx.orgId)),
				),
			)
			.one();
	}),
} as const;
